import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'RSI' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'RSI', label: 'Relative Strength Index', pane: 'sub', params: [6, 12, 24], outputs: ['rsi1', 'rsi2', 'rsi3'], labels: ['Period 1', 'Period 2', 'Period 3'], levels: [70, 50, 30] })
